import React, { memo } from "react";
import { TextField } from "@material-ui/core";
import MaskService from "../../utils/mask/maskService";
import "./basics.css";

const TextFieldCustom = ({
  maxLength,
  mask = null,
  setValue,
  size = "small",
  onChange = (e) => {
    if (maxLength && e.target.value.length >= maxLength) {
      setValue(e.target.value.substring(0, maxLength));
      return;
    }

    mask
      ? setValue(MaskService.toMask(mask, e.target.value))
      : setValue(e.target.value);
  },
  ...props
}) => {
  return (
    <TextField
      {...props}
      size={size}
      onChange={(e) => {
        onChange(e);
      }}
      className="filter-input"
      error={!!props.error}
    ></TextField>
  );
};

export default memo(TextFieldCustom);
